import React from 'react';
import { motion } from 'framer-motion';
import { Zap, ShieldCheck, Lock, CreditCard, Clock, Check, AlertTriangle, Folder, PenTool } from 'lucide-react';
import { Countdown } from './Countdown';
export function FinalCTA() {
  return <section className="py-14 bg-petroleum relative overflow-hidden border-t border-electric/20" data-id="element-272">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[800px] bg-radial-glow pointer-events-none opacity-40" data-id="element-273"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-274">
        {/* Framed Countdown Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="relative max-w-3xl mx-auto mb-10 mt-4" data-id="element-275">
          {/* Section Folder Tab */}
          <div className="absolute -top-5 left-6 md:left-10 z-20" data-id="element-276">
            <div className="bg-petroleum border-2 border-b-0 border-red-500/40 rounded-t-lg px-4 py-1.5 flex items-center gap-2 transform -rotate-2" data-id="element-277">
              <Folder className="w-3.5 h-3.5 text-red-400" data-id="element-278" />
              <span className="text-[11px] font-mono font-bold uppercase tracking-widest text-red-400" data-id="element-279">
                Oferta — Vence Pronto
              </span>
            </div>
          </div>

          <div className="absolute -inset-1 bg-gradient-to-r from-red-500 via-red-400 to-red-500 rounded-3xl blur-xl opacity-25 animate-pulse" data-id="element-280"></div>
          <div className="relative bg-gradient-to-br from-graphite via-petroleum to-graphite border-2 border-red-500 rounded-3xl p-8 md:p-10 text-center overflow-hidden shadow-2xl shadow-red-500/20" data-id="element-281">
            {/* Stamp */}
            <div className="absolute top-6 right-6 z-20 pointer-events-none select-none" style={{
            transform: 'rotate(15deg)'
          }} data-id="element-282">
              <div className="border-[3px] border-red-500/60 rounded-lg px-3 py-1" data-id="element-283">
                <span className="text-red-500/80 font-extrabold tracking-widest text-sm uppercase" data-id="element-284">
                  Urgente
                </span>
              </div>
            </div>

            <div className="absolute inset-0 opacity-[0.08] pointer-events-none" style={{
            backgroundImage: 'linear-gradient(rgba(239,68,68,0.6) 1px, transparent 1px), linear-gradient(90deg, rgba(239,68,68,0.6) 1px, transparent 1px)',
            backgroundSize: '24px 24px'
          }} data-id="element-285"></div>
            <div className="absolute top-0 left-0 w-14 h-14 border-t-4 border-l-4 border-red-500 rounded-tl-3xl pointer-events-none" data-id="element-286"></div>
            <div className="absolute top-0 right-0 w-14 h-14 border-t-4 border-r-4 border-red-500 rounded-tr-3xl pointer-events-none" data-id="element-287"></div>
            <div className="absolute bottom-0 left-0 w-14 h-14 border-b-4 border-l-4 border-red-500 rounded-bl-3xl pointer-events-none" data-id="element-288"></div>
            <div className="absolute bottom-0 right-0 w-14 h-14 border-b-4 border-r-4 border-red-500 rounded-br-3xl pointer-events-none" data-id="element-289"></div>

            <div className="relative z-10" data-id="element-290">
              <div className="inline-flex items-center gap-2 bg-red-500 text-white px-4 py-1.5 rounded-full text-xs font-extrabold uppercase tracking-wider mb-5 shadow-lg shadow-red-500/40" data-id="element-291">
                <AlertTriangle className="w-3.5 h-3.5" strokeWidth={2.5} data-id="element-292" />
                Última oportunidad
              </div>
              <h2 className="text-2xl md:text-4xl font-extrabold leading-tight mb-5" data-id="element-293">
                <span className="text-white" data-id="element-294">El precio </span>
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-red-400 via-red-300 to-red-400 drop-shadow-[0_0_12px_rgba(239,68,68,0.4)]" data-id="element-295">
                  cierra en:
                </span>
              </h2>
              <Countdown data-id="element-296" />
              <div className="mt-5 mx-auto h-px w-32 bg-gradient-to-r from-transparent via-red-500 to-transparent opacity-70" data-id="element-297"></div>
            </div>
          </div>
        </motion.div>

        <div className="max-w-4xl mx-auto grid md:grid-cols-2 gap-6 mb-8" data-id="element-298">
          {/* Basic Plan Mini */}
          <div className="bg-graphite border border-white/10 rounded-2xl p-6 text-center hover:border-electric/30 transition-all relative mt-3" data-id="element-299">
            {/* Card Folder Tab */}
            <div className="absolute -top-3 left-4 z-20" data-id="element-300">
              <div className="bg-petroleum border border-electric/30 rounded-t-md px-2 py-0.5 flex items-center gap-1 transform -rotate-2" data-id="element-301">
                <Folder className="w-2.5 h-2.5 text-textsecondary" data-id="element-302" />
                <span className="text-[9px] font-mono font-bold uppercase tracking-widest text-textsecondary" data-id="element-303">
                  Oferta A
                </span>
              </div>
            </div>

            <h3 className="text-xl font-bold mb-2 mt-2" data-id="element-304">
              📘 SUPERPACK ENTREVISTAS
            </h3>
            <p className="text-sm text-textsecondary mb-4" data-id="element-305">6 Tomos + 6 Bonos</p>
            <div className="mb-6" data-id="element-306">
              <span className="text-textsecondary line-through text-sm mr-2" data-id="element-307">
                $29.990
              </span>
              <span className="text-3xl font-extrabold text-white" data-id="element-308">
                $14.490
              </span>
            </div>
            <div className="flex flex-col gap-2" data-id="element-309">
              <div className="flex items-center justify-center gap-1 text-[9px] font-mono uppercase tracking-widest text-electric/70" data-id="element-310">
                <PenTool className="w-2.5 h-2.5" data-id="element-311" />
                Firma Aquí ↓
              </div>
              <a href="https://www.bibliotecasdigitales.store/checkouts/cn/hWNCozc29zdZ0C2K8raHFWoE/es-ar?_r=AQAB0salDLYbU5UgFanW6R0pUA1sZzkTGH7zYWd91gxBRt8&cart_link_id=GQstsdmk&preview_theme_id=154708803747" target="_blank" rel="noopener noreferrer" className="group relative w-full bg-gradient-to-r from-petroleum to-petroleum/80 hover:from-electric/20 hover:to-electric/10 border border-electric/50 hover:border-electric text-white font-bold py-3 rounded-xl transition-all duration-300 flex items-center justify-between gap-2 pl-3 pr-2 shadow-md hover:shadow-lg hover:shadow-electric/20" data-id="element-312">
                <span className="flex-shrink-0 w-7 h-7 rounded-lg bg-electric/15 border border-electric/30 flex items-center justify-center group-hover:bg-electric/25 transition-colors" data-id="element-313">
                  <Zap className="w-3.5 h-3.5 text-electric fill-electric" data-id="element-314" />
                </span>
                <span className="flex-1 text-center text-sm tracking-wide" data-id="element-315">
                  ACEPTAR OFERTA A
                </span>
                <span className="flex-shrink-0 w-7 h-7 rounded-lg bg-electric/15 text-electric flex items-center justify-center group-hover:translate-x-0.5 transition-transform" data-id="element-316">
                  <Check className="w-3.5 h-3.5" strokeWidth={3} data-id="element-317" />
                </span>
              </a>
            </div>
          </div>

          {/* Pro Plan Mini */}
          <div className="bg-gradient-to-b from-cardbg to-petroleum border-2 border-electric rounded-2xl p-6 text-center relative glow-electric mt-3" data-id="element-318">
            {/* Card Folder Tab */}
            <div className="absolute -top-3 left-4 z-20" data-id="element-319">
              <div className="bg-electric border border-electric rounded-t-md px-2 py-0.5 flex items-center gap-1 transform -rotate-2" data-id="element-320">
                <Folder className="w-2.5 h-2.5 text-graphite" data-id="element-321" />
                <span className="text-[9px] font-mono font-bold uppercase tracking-widest text-graphite" data-id="element-322">
                  Oferta B
                </span>
              </div>
            </div>

            <div className="absolute -top-3 right-4 bg-gold text-graphite font-bold px-3 py-0.5 rounded-full text-xs flex items-center gap-1 shadow-md" data-id="element-323">
              <Zap className="w-3 h-3 fill-graphite" data-id="element-324" /> MÁS POPULAR
            </div>
            <h3 className="text-xl font-bold mb-2 text-gold mt-2" data-id="element-325">
              🏆 SUPERPACK + PROTOCOLO TOTAL
            </h3>
            <p className="text-sm text-textsecondary mb-4" data-id="element-326">
              6 Tomos + 6 Bonos + Protocolo
            </p>
            <div className="mb-6" data-id="element-327">
              <span className="text-textsecondary line-through text-sm mr-2" data-id="element-328">
                $42.990
              </span>
              <span className="text-3xl font-extrabold text-white" data-id="element-329">
                $24.990{' '}
                <span className="text-lg text-textsecondary font-medium" data-id="element-330">
                  ARS
                </span>
              </span>
            </div>
            <div className="flex flex-col gap-2" data-id="element-331">
              <div className="flex items-center justify-center gap-1 text-[9px] font-mono uppercase tracking-widest text-gold" data-id="element-332">
                <PenTool className="w-2.5 h-2.5" data-id="element-333" />
                Firma Aquí ↓
              </div>
              <a href="https://www.bibliotecasdigitales.store/checkouts/cn/hWNCozpP0Akks8fx9V9l7kEE/es-ar?_r=AQABqGUydzRQpIZhFczAn0kTKpof-0DWODM9u3VFHsdt5wc&cart_link_id=Ycod5L72&preview_theme_id=154708803747" target="_blank" rel="noopener noreferrer" className="group relative w-full bg-gradient-to-r from-gold/90 to-gold hover:from-yellow-300 hover:to-yellow-400 border border-yellow-200 text-graphite font-bold py-3 rounded-xl transition-all duration-300 flex items-center justify-between gap-2 pl-3 pr-2 shadow-md hover:shadow-lg hover:shadow-gold/40" data-id="element-334">
                <span className="flex-shrink-0 w-7 h-7 rounded-lg bg-graphite/15 border border-graphite/20 flex items-center justify-center" data-id="element-335">
                  <Zap className="w-3.5 h-3.5 text-graphite fill-graphite" data-id="element-336" />
                </span>
                <span className="flex-1 text-center text-sm tracking-wide" data-id="element-337">
                  ACEPTAR OFERTA B
                </span>
                <span className="flex-shrink-0 w-7 h-7 rounded-lg bg-graphite text-gold flex items-center justify-center group-hover:translate-x-0.5 transition-transform" data-id="element-338">
                  <Check className="w-3.5 h-3.5" strokeWidth={3} data-id="element-339" />
                </span>
              </a>
            </div>
          </div>
        </div>

        {/* Trust Row */}
        <div className="flex flex-wrap items-center justify-center gap-6 md:gap-12 text-sm text-textsecondary font-medium" data-id="element-340">
          <div className="flex items-center gap-2" data-id="element-341">
            <Lock className="w-5 h-5 text-electric" data-id="element-342" /> Pago 100% seguro
          </div>
          <div className="flex items-center gap-2" data-id="element-343">
            <Clock className="w-5 h-5 text-electric" data-id="element-344" /> Acceso en 5 minutos
          </div>
          <div className="flex items-center gap-2" data-id="element-345">
            <ShieldCheck className="w-5 h-5 text-electric" data-id="element-346" /> Garantía 7 días
          </div>
          <div className="flex items-center gap-2" data-id="element-347">
            <CreditCard className="w-5 h-5 text-electric" data-id="element-348" /> Mercado Pago —
            Tarjeta — Transferencia
          </div>
        </div>
      </div>
    </section>;
}